import styled from "styled-components"
import { Link } from "gatsby"
import { motion } from "framer-motion"

export const Brand = styled(Link)`
  display: inline-flex;
  flex: 1 200px;
  position: relative;
  align-items: center;
  justify-content: center;
  height: 100%;
  pointer-events: ${props => props.disabled ? "none" : "inherit"};
`

export const BrandLogo = styled(motion.img)`
  position: relative;
  object-fit: contain;  
  width: 80%;
  height: 80%;
`
